<script>
  import ListVideo from "@components/List/Video";

  export default {
    components: {
      ListVideo
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    computed: {
      formattedList() {
        return this.list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          brands: item.brands[0],
          to: {
            name: 'brand-video-item',
            params: {
              brandAlias: this.$route.params.brandAlias,
              categoryAlias: item.category_alias,
              videoAlias: item.alias,
            },
          },
          videoId: this.formattedVideoId(item.extrafields.youtube_url.value)
        }))
      },
    },
    methods: {
      formattedVideoId(id) {
        if(id.includes('=')){
          return id.split('=')[1]
        } else {
          return id.split('/')[id.split('/').length - 1]
        }
      },
    }
  }
</script>
<template>
  <section id="video" class="section">
    <div class="container">
      <BaseSectionTitle
        title="產品影片"
        class="text-center"
      />
      <ListVideo
        :list="formattedList"
        type="carousel"
        link-type="list"
      />
      <div class="text-center position-relative" style="z-index: 0;">
        <BaseButton
          class="isStylePrimary isRadius isCol4"
          :to="{ name: 'brand-video-list' }"
        >
          查看所有影片
        </BaseButton>
      </div>
    </div>
  </section>
</template>
